<template>
  <div class="license-overview pa-4">
    <div class="d-flex justify-space-between align-center mb-6">
      <h3 class="text-h5 font-weight-bold white--text">Lizenz-Matrix</h3>
      <v-btn color="#D4AF37" class="black--text" @click="exportExcel" :loading="exporting">
        <v-icon left>mdi-file-excel</v-icon> Excel Export
      </v-btn>
    </div>

    <v-card dark class="pa-6 rounded-xl" style="background: rgba(30, 30, 30, 0.8)">
      <v-row class="mb-4">
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Name suchen..."
            outlined
            dense
            hide-details
            color="#D4AF37"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="studioFilter"
            :items="['Alle', 'Frauenfeld', 'St. Gallen', 'Zürich']" 
            label="Studio"
            outlined
            dense
            hide-details
            color="#D4AF37"
          ></v-select>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="filteredReports"
        :loading="loading"
        :search="search"
        dark
        class="elevation-0 transparent-bg"
      >
        <template v-slot:item.user="{ item }">
          <div class="font-weight-bold">{{ item.user.firstName }} {{ item.user.lastName }}</div>
          <div class="text-caption grey--text">{{ item.user.role || 'Member' }}</div>
        </template>
        
        <template v-slot:item.bronze="{ item }">
          <v-icon :color="item.bronze ? '#CD7F32' : 'grey darken-3'">
            {{ item.bronze ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
          </v-icon>
        </template>
        
        <template v-slot:item.silber="{ item }">
          <v-icon :color="item.silber ? '#C0C0C0' : 'grey darken-3'">
            {{ item.silber ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
          </v-icon>
        </template>
        
        <template v-slot:item.gold="{ item }">
          <v-icon :color="item.gold ? '#FFD700' : 'grey darken-3'">
            {{ item.gold ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "LicenseOverview",
  data() {
    return {
      reports: [],
      loading: false,
      exporting: false,
      search: "",
      studioFilter: "Alle",
      headers: [
        { text: "Mitarbeiter", value: "user" },
        { text: "Studio", value: "studio" },
        { text: "Bronze", value: "bronze", align: "center" },
        { text: "Silber", value: "silber", align: "center" },
        { text: "Gold", value: "gold", align: "center" },
      ]
    };
  },
  computed: {
    filteredReports() {
      if (this.studioFilter === "Alle") return this.reports;
      return this.reports.filter(r => r.studio === this.studioFilter);
    }
  },
  mounted() {
    this.loadReports();
  },
  methods: {
    async loadReports() {
      this.loading = true;
      try {
        const res = await api.akademie.fetchLicenseOverview();
        this.reports = res || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async exportExcel() {
      this.exporting = true;
      try {
        await api.akademie.exportLicenseOverviewExcel({ studio: this.studioFilter !== 'Alle' ? this.studioFilter : null });
      } catch (e) {
        console.error(e);
      } finally {
        this.exporting = false;
      }
    }
  }
};
</script>

<style scoped>
.transparent-bg {
  background-color: transparent !important;
}
</style>
